<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/elements-content -->
<p-contextmenu #cm [model]="_contextMenu" (onHide)="_contextMenuSelection = null" appendTo="body" />

<p-table
    #ptable
    stripedRows
    [dataKey]="dataKey"
    [columns]="selectedColumns"
    [value]="dataAsRowData"
    [loading]="showTableLoading"
    [globalFilterFields]="searcheableFields"
    [paginator]="showPaginator || showBasicPaginator"
    [lazy]="showPaginator || pushDataOnFly"
    (onLazyLoad)="showPaginator ? onPageChange($event) : undefined"
    [lazyLoadOnInit]="false"
    (onPage)="showBasicPaginator ? onSimplePageChange() : undefined"
    [totalRecords]="showPaginator ? totalCount : 1"
    [rowsPerPageOptions]="ROWS_PER_PAGE_OPTIONS"
    (sortFunction)="sortFn?.($event)"
    (onRowReorder)="onRowReorder?.($event)"
    [first]="showPaginator ? paginatorConfig.offset : 0"
    [rows]="showPaginator ? paginatorConfig.limit : ROWS_PER_PAGE_OPTIONS[0]"
    [sortOrder]="paginatorConfig.order || 1"
    [filterDelay]="1000"
    [resizableColumns]="true"
    [autoLayout]="true"
    [scrollable]="true"
    [scrollHeight]="scrollHeight ?? (flexHeight == true ? 'flex' : undefined)"
    [customSort]="!!sortFn"
    [sortField]="paginatorConfig.sort"
    styleClass="p-datatable-striped p-datatable-gridlines"
    paginatorDropdownAppendTo="body"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [reorderableColumns]="true"
    [expandedRowKeys]="expandedRowKeys"
    (onContextMenuSelect)="contextMenuSelect($event)"
    [contextMenu]="_contextMenu ? cm : undefined"
    [(contextMenuSelection)]="_contextMenuSelection"
>
    <ng-template pTemplate="caption" *ngIf="showTopBar || showColumnToggle || showAutoRefresh">
        <div class="header-flex">
            <div style="display: flex; gap: 0.5rem">
                @if (showSearch && searcheableFields.length > 0) {
                    <div style="width: 20rem; display: inline-block">
                        <p-iconfield>
                            <p-inputicon class="pi pi-search" />
                            <input
                                [id]="_tableID + 'SearchBar'"
                                pInputText
                                type="text"
                                [value]="_searchValue ?? ''"
                                (input)="ptable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="Search words"
                            />
                        </p-iconfield>
                    </div>
                }
                @if (showAutoRefresh) {
                    <app-auto-refresh
                        [defaultInterval]="autoRefreshDefaultInterval"
                        [disabled]="showTableLoading"
                        (refresh)="refreshEvent.emit()"
                    ></app-auto-refresh>
                }
            </div>

            @if (showRefreshButton || showHelpButton || showNewButton || showFilterButton) {
                <div class="caption-buttons">
                    @if (showColumnToggle && showColumnChooser) {
                        <div style="width: 15rem; display: inline-block">
                            <p-multiSelect
                                [options]="_dataCols"
                                [(ngModel)]="selectedColumns"
                                optionLabel="header"
                                selectedItemsLabel="{0} columns selected"
                                [style]="{'text-transform': 'capitalize'}"
                                placeholder="Choose Columns"
                                [ngModelOptions]="{standalone: true}"
                            ></p-multiSelect>
                        </div>
                    }
                    @if (showFilterButton) {
                        <p-button
                            severity="secondary"
                            icon="pi pi-filter-fill"
                            (click)="onFilterClick()"
                            [label]="'Filter'"
                        />
                    }
                    @if (showRefreshButton) {
                        <p-button severity="secondary" icon="pi pi-refresh" (click)="refreshEvent.emit()" />
                    }
                    @if (showHelpButton) {
                        <p-button severity="secondary" icon="pi pi-question" (click)="helpEvent.emit()" />
                    }
                    @if (showNewButton) {
                        <p-button
                            severity="primary"
                            (click)="newEvent.emit()"
                            [label]="newButtonCaption || 'Add new'"
                        />
                    }
                </div>
            }
        </div>
    </ng-template>

    <ng-template pTemplate="loadingbody">
        @for (idx of [0, 1, 2, 3, 4, 5]; track idx) {
            <tr>
                @for (col of selectedColumns; track col.__iID) {
                    <td>
                        <p-skeleton></p-skeleton>
                    </td>
                }
                @if (_buttonCols.length > 0 || _contextMenu) {
                    <td [ngStyle]="{width: _buttonsColWidth}">
                        <p-skeleton></p-skeleton>
                    </td>
                }
            </tr>
        }
    </ng-template>

    <ng-template pTemplate="loadingicon">
        <p-progress-spinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progress-spinner>
        <div class="mt-2 mb-2" [ngStyle]="{color: 'white', fontSize: '1.5rem', fontWeight: 'bold'}">
            {{ tableLoadingStr }}
        </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="50">
                @if (data.length === 0 && !showTableError) {
                    <p-message severity="warn">There is nothing to show.</p-message>
                }
                @if (showTableError) {
                    <p-message severity="warn">An error occured while getting datas.</p-message>
                }
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="header">
        <tr>
            @if (_subRowColumn !== undefined) {
                <th style="width: 5rem"></th>
            }
            @for (col of selectedColumns; track col.__iID) {
                @let colCache = _colsCache[col.__iID!];

                @if (col.sortable && colCache.conditionEval[isRootTable ? 1 : 0]) {
                    <th
                        [pSortableColumn]="col.field"
                        [alignFrozen]="colCache.freezeDirection"
                        pFrozenColumn
                        [frozen]="!!col.freeze"
                        pResizableColumn
                        pReorderableColumn
                        [ngStyle]="{width: col.colWidth}"
                    >
                        {{ col.header | titlecase }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                } @else {
                    @if (!col.sortable && colCache.conditionEval[isRootTable ? 1 : 0]) {
                        <th
                            [alignFrozen]="colCache.freezeDirection"
                            pFrozenColumn
                            [frozen]="!!col.freeze"
                            pResizableColumn
                            pReorderableColumn
                            [ngStyle]="{width: col.colWidth}"
                        >
                            {{ col.header | titlecase }}
                        </th>
                    }
                }
            }

            @if (_buttonCols.length > 0 || _contextMenu) {
                <th [ngStyle]="{width: _buttonsColWidth}" alignFrozen="right" pFrozenColumn></th>
            }
        </tr>

        @if (filterableFields.length > 0 && !showTableLoading && showFilters) {
            <tr>
                @if (_subRowColumn !== undefined) {
                    <th></th>
                }

                @for (col of selectedColumns; track col.__iID) {
                    @let colCache = _colsCache[col.__iID!];

                    @if (col.filterable && col.filterType) {
                        <th
                            class="filtered-columns"
                            [alignFrozen]="colCache.freezeDirection"
                            pFrozenColumn
                            [frozen]="!!col.freeze"
                        >
                            <p-columnFilter
                                matchMode="contains"
                                [showMenu]="false"
                                class="fullwidth"
                                [type]="col.filterType === ETableColFilterType.BOOLEAN ? 'boolean' : 'text'"
                                [field]="col.field"
                            >
                                @switch (col.filterType) {
                                    @case (ETableColFilterType.TEXT) {
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <input
                                                pInputText
                                                type="text"
                                                [value]="getFilterRowValue(col.field) || value"
                                                (keydown.enter)="applyFilterOnKeyDown($event, filter)"
                                                placeholder="Any"
                                            />
                                        </ng-template>
                                    }
                                    @case (ETableColFilterType.DATE) {
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-datepicker
                                                appendTo="body"
                                                rangeSeparator="|"
                                                [ngModel]="getFilterRowValue(col.field) || value"
                                                ngDefaultControl
                                                (keydown.enter)="applyFilterOnKeyDown($event, filter)"
                                                (ngModelChange)="convertIntervalDate($event, filter)"
                                                (onClear)="filter(null)"
                                                [showClear]="true"
                                                selectionMode="range"
                                                placeholder="Interval"
                                            />
                                        </ng-template>
                                    }
                                    @case (ETableColFilterType.SELECT) {
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-select
                                                [ngModel]="
                                                    getFilterRowValue(col.field) ||
                                                    value ||
                                                    getDefaultValue(col, filter)
                                                "
                                                [options]="col.filterSelectOptions"
                                                optionLabel="label"
                                                optionValue="value"
                                                (onChange)="filter($event.value)"
                                                placeholder="Any"
                                                [showClear]="true"
                                                appendTo="body"
                                            >
                                                <ng-template #item let-option>
                                                    @if (option.icon) {
                                                        <p-tag
                                                            [value]="option.label"
                                                            [rounded]="true"
                                                            [style]="option.style"
                                                            [pTooltip]="option.tooltip"
                                                            [styleClass]="option.styleClass"
                                                        >
                                                            <i [class]="option.icon" [ngStyle]="option.iconStyle"></i>
                                                        </p-tag>
                                                    } @else {
                                                        <p-tag
                                                            [value]="option.label"
                                                            [rounded]="true"
                                                            [style]="option.style"
                                                            [pTooltip]="option.tooltip"
                                                            [styleClass]="option.styleClass"
                                                        ></p-tag>
                                                    }
                                                </ng-template>
                                            </p-select>
                                        </ng-template>
                                    }
                                    @case (ETableColFilterType.MULTISELECT) {
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-multiselect
                                                [ngModel]="getFilterRowValue(col.field) || value"
                                                ngDefaultControl
                                                [options]="col.filterSelectOptions || []"
                                                optionLabel="label"
                                                optionValue="value"
                                                (onChange)="filter($event.value)"
                                                placeholder="Any"
                                                appendTo="body"
                                            >
                                                <ng-template let-option pTemplate="item">
                                                    <p-tag
                                                        [value]="option.label"
                                                        [rounded]="true"
                                                        [icon]="getFilterRowTagOpt(col, option.value)?.icon"
                                                        [style]="getFilterRowTagOpt(col, option.value)?.style"
                                                        [pTooltip]="option.tooltip"
                                                        [styleClass]="getFilterRowTagOpt(col, option.value)?.styleClass"
                                                    ></p-tag>
                                                </ng-template>
                                            </p-multiselect>
                                        </ng-template>
                                    }
                                }
                            </p-columnFilter>
                        </th>
                    } @else {
                        <th [alignFrozen]="colCache.freezeDirection" pFrozenColumn [frozen]="!!col.freeze"></th>
                    }
                }
                @if (_buttonCols.length > 0 || _contextMenu) {
                    <th [ngStyle]="{width: _buttonsColWidth}" alignFrozen="right" pFrozenColumn></th>
                }
            </tr>
        }
    </ng-template>

    <ng-template pTemplate="body" let-row let-expanded="expanded" let-rowIndex="rowIndex">
        @if (!showTableLoading) {
            <tr
                [class]="rowWrapperClassList"
                [pReorderableRow]="
                    onRowReorder && paginatorConfig.sort === 'order' && paginatorConfig.order === 1 ? rowIndex : null
                "
                [pContextMenuRow]="row"
            >
                @if (_subRowColumn !== undefined) {
                    @let childrenRows = _subRowColumn.fnChildrenRows?.(row);

                    <td>
                        @if (childrenRows?.length) {
                            <p-button
                                type="button"
                                pRipple
                                [pRowToggler]="row"
                                [text]="true"
                                [rounded]="true"
                                [plain]="true"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            />
                        }
                    </td>
                }

                @for (col of selectedColumns; track col.__iID) {
                    @let colCache = _colsCache[col.__iID!];

                    @if (col.type === ETableColType.DATA || col.type === ETableColType.ORDER) {
                        @let isOrderCol = col.type === ETableColType.ORDER;
                        @if (colCache.conditionEval[isRootTable ? 1 : 0]) {
                            <td
                                [pTooltip]="col.tooltipField ? get(row, col.tooltipField) : (col.tooltip ?? '')"
                                [pEditableColumn]="
                                    col.dataType === ETableColDataType.EDITABLE_TEXT ? row[col.field] : null
                                "
                                [pEditableColumnRowIndex]="
                                    col.dataType === ETableColDataType.EDITABLE_TEXT ? rowIndex : null
                                "
                                [pEditableColumnField]="
                                    col.dataType === ETableColDataType.EDITABLE_TEXT ? colCache.index : null
                                "
                                [alignFrozen]="colCache.freezeDirection"
                                pFrozenColumn
                                [frozen]="!!col.freeze"
                                [ngStyle]="col?.tdStyle"
                                [ngStyle]="{width: col.colWidth}"
                            >
                                @if (isOrderCol && onRowReorder) {
                                    <span
                                        class="pi pi-bars d-flex align-items-center"
                                        [style]="
                                            paginatorConfig.sort !== 'order' || paginatorConfig.order !== 1
                                                ? 'opacity: 0.5'
                                                : ''
                                        "
                                        (pReorderableRowHandle)="(rowIndex)"
                                        [pTooltip]="
                                            paginatorConfig.sort !== 'order' || paginatorConfig.order !== 1
                                                ? 'Reorder can only be done on the if the table is sorted by Order ascending'
                                                : ''
                                        "
                                    >
                                        <span class="p-component margin-left-10">{{ row[col.field] }}</span>
                                    </span>
                                }

                                <div
                                    (click)="
                                        col.dataType != ETableColDataType.LINK ? col.fnOnCellClick?.(row) : undefined
                                    "
                                    [class]="colCache.wrapperClassList"
                                >
                                    @if (col.fnCustomData) {
                                        <div
                                            [class]="col.fnCellWrappingClassName?.(row) ?? ''"
                                            *ngTemplateOutlet="
                                                cellDataTemplate;
                                                context: {
                                                    colID: col.__iID,
                                                    row: row,
                                                    colValue: col.fnCustomData(row)
                                                }
                                            "
                                        ></div>
                                    } @else {
                                        <div
                                            [class]="col.fnCellWrappingClassName?.(row) ?? ''"
                                            *ngTemplateOutlet="
                                                cellDataTemplate;
                                                context: {colID: col.__iID, row: row, colValue: get(row, col.field)}
                                            "
                                        ></div>
                                    }
                                </div>
                            </td>
                        }
                    }
                }

                @if (_buttonCols.length > 0 || _contextMenu) {
                    <td [ngStyle]="{width: _buttonsColWidth}" alignFrozen="right" pFrozenColumn>
                        <div class="btn-flex">
                            @for (col of cols; track col.__iID) {
                                @if (col.type === ETableColType.BUTTON) {
                                    <p-button
                                        [pTooltip]="col.tooltip || ''"
                                        [icon]="col.icon ?? ''"
                                        [severity]="col.buttonSeverity ?? 'primary'"
                                        (click)="col.fnOnButtonClick?.(row)"
                                        size="small"
                                    />
                                }
                            }
                            @if (_contextMenu) {
                                <p-button
                                    severity="secondary"
                                    (click)="
                                        contextMenuSelect({originalEvent: $event, index: rowIndex, data: row});
                                        cm.show($event)
                                    "
                                    icon="pi pi-ellipsis-h"
                                    size="small"
                                />
                            }
                        </div>
                    </td>
                }
            </tr>
        }
    </ng-template>

    <ng-template #expandedrow let-row>
        @let subRows = getChildrenInCols(row);
        @if (!showLoading && subRows && subRows.length > 0) {
            <tr>
                <td colspan="1000">
                    <div>
                        <app-generic-table
                            [data]="subRows"
                            [cols]="cols"
                            [dataKey]="row.id"
                            [isRootTable]="false"
                            [showTopBar]="showNonRootTopBar"
                            [showColumnToggle]="false"
                            [showSearch]="showNonRootSearch"
                            [showRefreshButton]="false"
                            [showHelpButton]="false"
                            [showNewButton]="false"
                            [showFilterButton]="false"
                            [showNewButton]="false"
                            [showTableLoading]="showTableLoading"
                            [showTableError]="false"
                            [showPaginator]="showNonRootPaginator"
                            [showBasicPaginator]="showNonRootBasicPaginator"
                        ></app-generic-table>
                    </div>
                </td>
            </tr>
        }
    </ng-template>
</p-table>

<ng-template #cellDataTemplate let-colID="colID" let-row="row" let-colValue="colValue">
    @let colCache = _colsCache[colID!]!;
    @let col = colCache.tableColDef!;
    @let cellValueAsBool = colValue !== null && colValue !== undefined ? !!colValue : false;

    @if (col.fnCustomPrefixIcon) {
        <span [classList]="col.fnCustomPrefixIcon(row)"></span>
    }

    @switch (col.dataType) {
        @case (ETableColDataType.LONG_TEXT) {
            <div>
                {{ colValue?.length > 100 ? (colValue | slice: 0 : 50) + '...' : colValue }}
            </div>
        }
        @case (ETableColDataType.IMAGE) {
            <div style="text-align: center">
                <div class="img-maintain-ratio">
                    <img [src]="colValue ?? '/assets/images/image_not_found.png'" alt="Image" />
                </div>
            </div>
        }
        @case (ETableColDataType.DATE) {
            {{ colValue | date: col.customDateFormat || SDKConfig.dateFormat }}
        }
        @case (ETableColDataType.BOOLEAN_LABEL) {
            @if (cellValueAsBool) {
                <p-tag value="Yes" [rounded]="true" [style]="colCache.booleanLabelStyleCache?.[0]"></p-tag>
            } @else {
                <p-tag value="No" [rounded]="true" [style]="colCache.booleanLabelStyleCache?.[1]"></p-tag>
            }
        }
        @case (ETableColDataType.BOOLEAN_ICON) {
            <i [class]="cellValueAsBool ? 'pi pi-check green' : ''"></i>
        }
        @case (ETableColDataType.BOOLEAN_ICON_INV) {
            <i [class]="cellValueAsBool ? '' : 'pi pi-check green'"></i>
        }
        @case (ETableColDataType.CHECKBOX) {
            <p-checkbox [value]="colValue" [readonly]="true"></p-checkbox>
        }
        @case (ETableColDataType.CONDITIONAL_CHECKBOX) {
            @if (colValue !== null && colValue !== undefined) {
                <p-checkbox [ngModel]="colValue" [binary]="true" [disabled]="colValue"></p-checkbox>
            }
        }
        @case (ETableColDataType.TAGS) {
            @for (tagOpts of col.tags || []; track tagOpts) {
                @if (tagOpts.value === null || tagOpts.value === undefined || tagOpts.value === colValue) {
                    @if (tagOpts.icon) {
                        <p-tag
                            [style]="tagOpts.style!"
                            [value]="tagOpts.label || colValue"
                            [rounded]="true"
                            [pTooltip]="tagOpts.tooltip"
                            [styleClass]="tagOpts.styleClass"
                        >
                            <i [class]="tagOpts.icon" [ngStyle]="tagOpts.iconStyle"></i>
                        </p-tag>
                    } @else {
                        <p-tag
                            [icon]="tagOpts.icon"
                            [style]="tagOpts.style!"
                            [value]="tagOpts.label || colValue"
                            [rounded]="true"
                            [pTooltip]="tagOpts.tooltip"
                            [styleClass]="tagOpts.styleClass"
                        ></p-tag>
                    }
                }
            }
        }
        @case (ETableColDataType.CHIPS) {
            @for (chip of colValue || []; track chip) {
                <p-chip [label]="chip" />
            }
        }
        @case (ETableColDataType.EDITABLE_TEXT) {
            <p-cellEditor>
                <ng-template pTemplate="input">
                    <input pInputText type="text" [(ngModel)]="row[col.field]" />
                </ng-template>
                <ng-template pTemplate="output">
                    {{ colValue }}
                </ng-template>
            </p-cellEditor>
        }
        @case (ETableColDataType.STATUS_TAG) {
            <app-status-tag
                [status]="colValue"
                [displayMode]="col.statusTagDisplayMode || EStatusTagDisplayMode.ICON"
                [isLocked]="col.statusTagLockEvalColumn ? row[col.statusTagLockEvalColumn] : false"
            ></app-status-tag>
        }
        @case (ETableColDataType.LINK) {
            <a (click)="col.fnOnCellClick?.(row)">{{ colValue }}</a>
        }
        @case (ETableColDataType.DATA_DISPLAY_CELL_COMPONENT) {
            @if (col.dataCellDisplayComponent) {
                <ng-template
                    *ngComponentOutlet="
                        col.dataCellDisplayComponent;
                        inputs: {
                            displayType: 'table',
                            extra: col.dataCellDisplayExtra,
                            rows: data,
                            row: row,
                            attribute: col.field,
                            value: col.fnCustomData?.(row) ?? colValue
                        }
                    "
                ></ng-template>
            } @else {
                <i>No component...</i>
            }
        }
        @default {
            {{ colValue }}
        }
    }
</ng-template>
